import store from "@/store/store";

export default {
  me() {
    return store.getters["user/account"];
  },
  myActiveAcl() {
    return store.getters["organization/acl"];
  },
  has(permission) {
    const account = store.getters["user/account"];
    if (!account) {
      return false;
    }
    return !!account.permissions.find((p) => p.id == permission);
  },
  aclHas(permission, orgAcl) {
    const acl = orgAcl || store.getters["organization/acl"];
    if (!acl) {
      return false;
    }

    return acl.roles.find((r) => r.permissions.find((p) => p.id == permission));
  },
};
